import {createSvgIcon} from './utils'

export const Pvz2FillIcon = createSvgIcon(
  <>
    <path
      d="M12.8484 12.9216C12.3568 12.9216 11.9582 13.3202 11.9582 13.8119V20.9339C11.9582 21.4256 12.3568 21.8241 12.8484 21.8241H19.9705C20.4621 21.8241 20.8607 21.4256 20.8607 20.9339V13.8119C20.8607 13.3202 20.4621 12.9216 19.9705 12.9216L12.8484 12.9216Z"
      fill="#21201F"
      opacity="0.4"
    />
    <path
      d="M10.3291 9.50375C11.9389 9.50375 13.2438 8.37486 13.2438 6.63637C13.2438 6.47674 13.2328 6.32155 13.2116 6.17134L13.6506 6.09707C14.2867 5.98945 14.7934 5.50565 14.9302 4.87517L15.0369 4.38366L12.2592 4.38833C11.7451 3.94256 11.0694 3.6864 10.3291 3.6864C8.71941 3.6864 7.41445 4.89788 7.41445 6.63637C7.41445 8.37486 8.71941 9.50375 10.3291 9.50375Z"
      fill="#21201F"
    />
    <path
      d="M9.07722 10.3242C7.66167 9.98944 6.24279 10.8656 5.90807 12.2812L3.94723 20.5735L3.89123 20.6368H1.93145C1.68562 20.6368 1.48633 20.8361 1.48633 21.0819V21.7599C1.48633 22.0058 1.68562 22.205 1.93145 22.205H21.3049C21.5507 22.205 21.75 22.0058 21.75 21.7599V21.0819C21.75 20.8361 21.5507 20.6368 21.3049 20.6368H9.16247L10.0314 17.602L10.0374 17.6227C10.1686 18.0745 10.5233 18.4035 10.9488 18.5201C11.0231 18.5545 11.102 18.5822 11.1848 18.6021L17.2124 20.0523C17.5122 19.0281 16.9563 17.9488 15.9485 17.5981L12.4393 16.3773L11.4332 11.8226C11.386 11.6092 11.2953 11.4172 11.1725 11.2536C10.9982 10.9455 10.7008 10.7081 10.3291 10.6202L9.07722 10.3242Z"
      fill="#21201F"
    />
  </>,
  'Pvz2Fill',
)
